<template>
	<div class="content-zsy">
		<div class="column-center">
			<h3>노데이타</h3>
			<div class="content-title" >
				<span v-if="info.tracking_name">{{info.tracking_name}}</span><span v-else>트래킹넘버</span>:{{info.tracking_no}}
			</div>
			<div class="content-date">
				{{info.createtime}} / {{info.nickname}}
			</div>
			<div class="content" v-html="info.content">
			</div>
			<div class="content-bottom">
				<el-button @click="onOneList">글목록</el-button>
			</div>
			
			<div class="" v-if="info.status == '0'">
				<div class="item-info">
					<el-form :model="ruleForm"  ref="ruleForm" label-width="0" >
						<div class="form-item" >
							<el-row>
								<el-col :xs="24" :sm="8" class="item">
									<div class="from-title">품목분류 <span class="required-addon">(*)</span></div>
									<el-form-item  prop="category_name"
									:rules="[
										{ required: true, message: '품목분류 필수', trigger: 'change' },
									]">
										<el-input v-model="ruleForm.category_name" readonly style="width: 110px;margin: 0 10px;" ></el-input>
										<el-button type="primary" size="small" @click="onCategoryDialog" >선택하기</el-button>
										<el-popover
										   placement="top-start"
										   width="300"
										   trigger="hover"
										   >
											<div>
										   	원하시는 품목분류가 없으신가요?<br>추가희망 하시는 품목분류를 고객센터로<br>알려주시면 즉시 추가하여드립니다
											</div>
											<i style="margin-left: 10px;" class="el-icon-question icon-question" slot="reference"></i>
										 </el-popover>
									</el-form-item>
								</el-col>
								<!-- 商品分类弹框 -->
								<el-dialog  :visible.sync="CategoryVisible" :width="isMobile?'90%':'40%'">
									<template slot="title">
										<div style="font-weight: bold;font-size: 20px;">분류선택</div>			
									</template>
									<div class="agency-category-customs">
										<el-row>
											<el-col :xs="24" :sm="8">
												<div>품목분류를 선택하세요.</div>
											</el-col>
											<el-col :xs="24" :sm="16" class="flex">
												<div class="type-general"></div><div style="width: 100px;">목록통관</div><div class="type-list"></div><div style="width: 150px;">간이(일반)통관</div>
											</el-col>
										</el-row>				    
									</div>
									<div class="help-block">
										<svg style="margin-right: 5px;" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
											<circle cx="12" cy="12" r="12" fill="#274A80"></circle>
											<path d="M13.4408 14.417H11.3158L11.1 6H13.6566L13.4408 14.417ZM12.3949 18.1689C12.1403 18.1689 11.9051 18.1053 11.6893 17.978C11.4735 17.8507 11.302 17.682 11.1747 17.4717C11.0529 17.2559 10.9948 17.0234 11.0004 16.7744C10.9948 16.5254 11.0529 16.2957 11.1747 16.0854C11.302 15.8752 11.4735 15.7091 11.6893 15.5874C11.9051 15.4601 12.1403 15.3965 12.3949 15.3965C12.6328 15.3965 12.857 15.4601 13.0673 15.5874C13.2831 15.7091 13.4546 15.8752 13.5819 16.0854C13.7092 16.2957 13.7728 16.5254 13.7728 16.7744C13.7728 17.0234 13.7092 17.2559 13.5819 17.4717C13.4546 17.682 13.2831 17.8507 13.0673 17.978C12.857 18.1053 12.6328 18.1689 12.3949 18.1689Z" fill="white"></path>
										</svg>
										상품명에 커서를 이동하면 참조용 [ HS-CODE, 관세율 &gt; FTA세율 ] 정보입니다.<br>
										자세한 정보는 "관세법령정보포탈" 사이트를 확인 바랍니다.
									</div>
									<div class="flex">
										<el-input
										  placeholder=""
										  v-model="search" style="width: 300px;margin-right: 10px;"
										  clearable>
										</el-input>
										<el-button type="primary" @click="onSearch">검색</el-button>
									</div>					
									
									<div class="agreement-box">
										<div class="height-fixed-box">
											<ol>
												<li class="depth1" v-for="(item, index) in category_list" v-if="item.subItem.length>0" :key="index" >
												    <strong class="namecolor-blue">{{item.name}}</strong>
												    <ol style="padding: 5px;">
														<li class="depth2" v-for="sub in item.subItem" :key="sub.id" >							
															<el-tooltip :content="sub.hs_code+' '+(sub.customs_tariff?sub.customs_tariff+'%':'-')+' > '+ (sub.fta_tariff?sub.fta_tariff+'%':'-') " placement="bottom-start">
																<span class="name" :class="sub.type==1?'color-blue':'color-red'" @click="onCategoryName(sub.id,sub.name)">{{sub.name}}</span>
															</el-tooltip>
														</li>
												    </ol>
												</li>
											</ol>						
										</div>  				
									</div>	  
								</el-dialog>
								
								<el-col :xs="24" :sm="8"  class="item">
									<div class="from-title">상품명(영문)<span class="required-addon">(*)</span></div>
									<el-form-item  prop="goods_name"
									:rules="[
										{ required: true, message: '상품명 필수', trigger: 'blur' },
									]">
										<el-input v-model="ruleForm.goods_name" class="input-frame" ></el-input>
										<el-popover
										   placement="top-start"
										   width="300"
										   trigger="hover"
										   >
										   <div>검색( HS코드네비게이션)에서 보다 정확한 결과를 얻을수 있습니다</div>
												<i class="el-icon-question icon-question" slot="reference"></i>
										</el-popover>
									</el-form-item>
								</el-col>
								<el-col :xs="24" :sm="8"  class="item">
									<div class="from-title">단가 <span class="required-addon">(*)</span></div><!--单价-->
									<el-form-item  prop="price"
									:rules="[
										{ required: true, message: '단가 필수', trigger: 'blur' },
									]">
										<el-input v-model="ruleForm.price" type="number" class="input-frame"  ></el-input>
										CNY
									</el-form-item>
								</el-col>
								<el-col :xs="24" :sm="8"  class="item">
									<div class="from-title">상품 URL <span class="required-addon">(*)</span></div>
									<el-form-item  prop="url"
									:rules="[
											{ required: true, message: '상품 URL 필수', trigger: 'blur' },
									]">
										<el-input v-model="ruleForm.url" type="url" class="input-frame" ></el-input>
									</el-form-item>
								</el-col>
								<el-col :xs="24" :sm="8"  class="item">
									<div class="from-title">주문번호 <span class="required-addon">(*)</span></div><!-- 订单号 -->
									<el-form-item  prop="order_no" :rules="[
										{ required: true, message: '주문번호 필수', trigger: 'blur' },
									]">
										<el-input v-model="ruleForm.order_no" class="input-frame" ></el-input>
										<el-popover
										   placement="top-start"
										   width="300"
										   trigger="hover"
										   >
										    <div>구매 주문번호를 입력해주세요</div>
											<i class="el-icon-question icon-question" slot="reference"></i>
										 </el-popover>
									</el-form-item>
								</el-col>
								<!-- 数量 -->
								<!-- <el-col :xs="24" :sm="8"  class="item">
									<div class="from-title">수량 <span class="required-addon">(*)</span></div>
									<el-form-item  prop="apply_quantity"
									:rules="[
										{ required: true, message: '수량 필수', trigger: 'blur' },
									]">
										<el-input v-model="ruleForm.apply_quantity" type="number" class="input-frame"  ></el-input>
										개
									</el-form-item>
								</el-col> -->
															
							</el-row>		
						</div>
											
					</el-form>
					<div style="text-align: center;margin: 0 0 30px;">
						<el-button  type="primary" @click="dialogVisible = true" round>등록하기</el-button>		
					</div>
					<el-dialog
					  :visible.sync="dialogVisible"
					  width="350px"
					  >
					  <span>이 택배 소포가 본인의 것인지 확인하시겠습니까?</span>
					  <span slot="footer" class="dialog-footer">
					    <el-button @click="dialogVisible = false">취소</el-button>
					    <el-button type="primary" @click="submitForm('ruleForm')">확인</el-button>
					  </span>
					</el-dialog>
					
				</div>
				
			</div>
			
		</div>
	</div>
</template>

<script>
	import request from '@/utils/request'
	export default {
		props: ['id'],
		data() {
			return {
				info:"",
				ruleForm: {
					category_id:"",
					category_name:"",
					goods_name:"",
					price:"",
					url:"",
					order_no:"",
					apply_quantity:"",
					
				},
				CategoryVisible: false,
				category_list:[],
				search: '',
				
				dialogVisible: false
			}
		},
		computed: {
			isMobile() {
			  return window.innerWidth <= 768;
			}
		},	
		created() {
			this.getDetail()
		},
		methods: {

				  
			getDetail(){
				request.post('/member/Goodsnodata/getNodataDetail',
					{
						id:this.id,
					}
				).then(res => {
					console.log(res.data,"xiangqing")
					if(res.code ==1){
						this.info = res.data
					}			
				});
			},
			onOneList(){
				this.$router.push(`/nodata`)
			},
			onSearch(){
				console.log(this.search)
				this.getCategoryList()
			},
			onCategoryDialog(){
				this.CategoryVisible = true
				this.getCategoryList()
			},
			getCategoryList(){
				request.post('/member/Agency/getCategoryList',{
					search:this.search
				})
				.then(res => {
					console.log(res,"212")
					if(res.code ==1){
						this.category_list = res.data
					}
						
				});
			},
			onCategoryName(id,name){
				console.log(id,"获取分类")
				this.CategoryVisible = false
				this.ruleForm.category_id =id
				this.ruleForm.category_name =name
			},
			submitForm(formName) {
				
				this.$refs[formName].validate((valid) => {
					if (valid) {
						console.log(this.ruleForm,"tijiao")
						// // 表单验证通过，准备提交数据
						// const submitData = {
						// 	items: [...this.ruleForm.items]
						// }
						// console.log(submitData,"结果")
						
						
						request.post('/member/Goodsnodata/registerNodata',
							{
								data:this.ruleForm,
								tracking_no:this.info.tracking_no,
							}
						).then(response => {
						console.log(response,"注册")			  
							if(response.code ==1){
								alert('제출 성공.');
								console.log(response,'提交成功！');
								
								this.$router.replace('/nodata');
							}else{
								alert(response.msg)
								console.log(response,'提交失败！');
								return
							}
							
						});

						
					} else {
						console.log('error submit!!');
							this.dialogVisible = false
						return false;
					}
					
				});
			}
			
		}
	
	}
</script>

<style scoped>
	.column-center h3 {
	    text-align: center;
	    font-size: 45px;
	    font-weight: bold;
	    color: var(--frontground-color);
	    padding: 60px 0 0 0;
	    margin: 0 0 60px;
	}
	.content-title{
		font-size: 24px;
		border-top: 2px solid #000;
		text-align: left;
		padding: 13px 15px;
		font-weight: 500;
		/* background-color: #f5f8fd; */
	}
	.content-date{
		padding: 20px 15px;
		color: #6a6a6a;
		border: solid 1px var(--border-color);
		border-width: 1px 0;
	}
	.content{
		max-width: 100%;
		padding: 20px 15px;
		border: solid 1px var(--border-color);
		border-width: 0 0 1px 0;
		color: var(--background-color);
		background-color: var(--frontground-color);
	}
	/deep/ .content img{
		max-width: 100%; /* 图片最大宽度不超过 .content 容器 */
		height: auto;    /* 保持图片纵横比，避免拉伸 */
		display: block;  /* 消除图片底部默认空白间隙 */
		/*  margin: 10px auto; 图片水平居中，上下留间距 */
		border-radius: 4px; /* 图片圆角，优化美观度 */
		object-fit: contain; /* 确保图片完整显示，不裁剪 */
	}
	/* 表单 */
	.item-info .form-item{
		padding-bottom: 30px;
	}
	.item-info .item{
		display: flex;
		align-items: center; 
		padding-bottom: 20px;
	}
	.from-title{
		width: 120px;
		padding-bottom: 20px;
	}
	.required-addon{
		font-family: inherit;
		color: var(--main-color);
		font-weight: inherit;
		vertical-align: inherit;
	}
	.input-frame{
		width: 200px;margin: 0 10px;
	}
	.icon-question{
		color:var(--main-color);padding-left: 5px;font-size: 18px;
	}
	/* 分类弹框 */
	.agency-category-customs{
		display: flex;
	}
	.agency-category-customs .type-general{
		background-color: #0055d4;
		width: 18px;
		height: 18px;
		border-radius: 6px;
		margin: 0 5px 0 15px;
	}
	.agency-category-customs .type-list{
		background-color: #c33;
		width: 18px;
		height: 18px;
		border-radius: 6px;
		margin: 0 5px 0 15px;
	}
	.help-block{
	    background-color: #d5e6fa;
	    color: #274780;
	    display: flex;
	    min-height: 40px;
		padding:5px 0;
	    border-radius: 12px;
	    align-items: center;
	    padding-left: 19px;
	    margin: 17px 0 20px;
	}
	.agreement-box{
		border: 1px solid var(--border-color);
		padding: 15px;
		margin: 25px 0 5px;
		border-radius: 20px;
	}
	.height-fixed-box{
		height: 400px;
		overflow-y: scroll;
		padding-right: 20px;
		font-size: 12px;
		color: #333;
	}
	.height-fixed-box ol {
	    margin: 0;
	    padding: 0;
	}
	.height-fixed-box .depth1 {
	    border: 1px solid #e5e5e5;
	    border-radius: 13px;
	    margin-bottom: 20px;
	}
	.height-fixed-box li {
	    margin: 0 0 30px 0;
	    padding: 0;
	    list-style: none;
	}
	.height-fixed-box li li {
	    display: inline-flex;
	    align-items: center;
	    margin: 0;
	    padding: 3px 5px;
	    width: 30%;
	    font-size: 13px;
	}
	.height-fixed-box li strong.namecolor-blue {
	    background-color: #0055d4;
	    border-top-left-radius: 8px;
	    border-top-right-radius: 8px;
	    padding: 9px 25px 6px;
	    font-size: 15px;
	    margin-bottom: 0;
	}
	.height-fixed-box li strong {
	    display: block;
	    background: #666;
	    color: #fff;
	    font-weight: 500;
	}
	.height-fixed-box .name{
		cursor: pointer;
	}
	.height-fixed-box .name:hover{
		text-decoration: underline; /* 悬停时添加下划线 */
	}

	
	.flex{
		display: flex;
	}
	.color-blue {
	    color: #0055d4 !important;
	}
	.color-red {
	    color: #cc3333 !important;
	}
	.content-bottom{
		padding:20px;
		display: flex;
		justify-content: end;
	}
	@media (min-width: 992px) {
		.content-zsy{
			width: 1270px;
			margin: 2.5rem auto;
		}
		
		
	}
	@media (max-width: 768px) {
		.item-info .item{
			padding:10px 20px;
			display: flex;
		}
		.from-title{
			font-size: 13px;
			width: 90px;
		}
	}
</style>